module.exports = __webpack_public_path__ + "static/media/21ECLAC44.cfe18056.jpg";